import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-users-and-groups',
  templateUrl: './users-and-groups.component.html',
  styleUrls: ['./users-and-groups.component.scss']
})
export class UsersAndGroupsComponent implements OnInit {


  isUsers: boolean = false;
  isGroups: boolean = false
  constructor() { }

  ngOnInit() {
    this.users();
  }


  users() {
    //console.log("Policy ", this.allPolicies)
    this.isUsers = true;
    this.isGroups=false

  }

  
  groups() {
    this.isGroups=true;
    this.isUsers = false

  }

}
